import {
  Button,
  Card,
  Col,
  FloatButton,
  Image,
  Input,
  Modal,
  Popover,
  Radio,
  Row,
  Space,
  Spin,
  Table,
  Tooltip,
} from "antd";
import { toJS } from "mobx";
import React, { Component } from "react";
import CompanyAutocomplete from "./CompanyAutocomplete";
import MultiTrackingStore from "../store/MultiTrackingStore";
import "./Tracking.css";
import "leaflet/dist/leaflet.css";

import { Icon, divIcon, point } from "leaflet";
import Draggable from "react-draggable";
import "leaflet/dist/leaflet.css";

import { GlobeCentralSouthAsia } from "react-bootstrap-icons";
import { CloseOutlined } from "@ant-design/icons";
import PolyLineAndMapComponent from "./PolyLineAndMapComponent";

import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import dayjs from "dayjs";
import ResizableTable from "./ResizableTable";
import { throttle } from "lodash";

class MultiTracking extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      companyId: "",
      loading: false,
      pageSize: 50,
      currentPage: 1,
      position: [],
      mapShow: false,
      latLongForModal: [],
      updateState: 0,
      newVehiclePosition: [],
      vehicleIds: [],
      updatedPos: false,
      showSlider: false,
      mapModalIndex: null,

      mapType: "google",
      listUpdated: 0,
      poupSearch: "",
      selectedRowKeys: [],
      alertModal: false,
      searchText: "",

      count: 0,
      clientHeight: window.innerHeight,
      searchData: [],

      selectedRowsInfo: [],

      hasMore: true,
      loading: false,
      

      columns: [
        {
          key: "vehicleNo",
          title: context.translate("_FLEET_DASHBORD_SEARCHVEHICLE_VEHICLE_"),
          dataIndex: "vehicleNo",
          width: 35,
          ellipsis: {
            showTitle: true,
          },
          render: (_, record) => {
            return (
              <Space>
                <Tooltip placement="topLeft" title={record.vehicleNo}>
                  <Image
                    width={38}
                    src={require("../assets/images/detailtracking/" +
                      record.listImage)}
                  />{" "}
                  &nbsp;
                  {record.vehicleNo}
                </Tooltip>
              </Space>
            );
          },
        },

        {
          key: "updatedate",
          title: context.translate("_TRACK_DATE_"),
          dataIndex: "updatedate",
          width: 20,
          ellipsis: {
            showTitle: true,
          },
          render: (val) => {
            const formattedDate = dayjs(val).format("DD-MM-YYYY h:mm:ss A");
            return (
              <Tooltip title={formattedDate}>
                <span>{formattedDate}</span>
              </Tooltip>
            );
          },
        },
      ],
    };
    this.mapOptions = [
      {
        label: "Google",
        value: "google",
      },
      {
        label: "Openstreet",
        value: "openstreet",
      },
    ];

    this.mapOptions = [
      {
        label: "Google",
        value: "google",
      },
      {
        label: "Openstreet",
        value: "openstreet",
      },
    ];

    this.multiTrackingStore = new MultiTrackingStore(this);
    this.mapRef = React.createRef();
    this.tableBodyRef = React.createRef();

    this.mapContainerRef = React.createRef();
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 1);
  }

  handleResize =
    (index) =>
    (_, { size }) => {
      this.setState((prevState) => {
        if (!Array.isArray(prevState.columns)) return null;

        const newColumns = [...prevState.columns];
        newColumns[index] = { ...newColumns[index], width: size.width };

        return { columns: newColumns };
      });
    };
  async componentDidMount() {
    this.handleResizeWindow();
    window.addEventListener("resize", throttle(this.handleResizeWindow, 200));
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }

    this.context.viewStateStore.setSliderChecker(true);
    let interval = 30000; // 30 seconds in milliseconds

    
    // await this.multiTrackingStore.loadData({
    //   offset: (this.state.currentPage - 1) * this.state.pageSize,
    //   limit: this.state.pageSize,
    //   searchField: this.state.searchField,
    //   companyId: this.state.companyId,
    //   isadmin: this.props.getUserData().isadmin,
    //   userCompanyId: this.props.getUserData().userCompanyId,
    //   userId: this.props.getUserData().userId
    // });
    //  await this.liveLatLongGetting()
    // this.intervalId = setInterval(async () => {
    //   await this.multiTrackingStore.loadData({
    //     offset: (this.state.currentPage - 1) * this.state.pageSize,
    //     limit: this.state.pageSize,
    //     searchField: this.state.searchField,
    //     companyId: this.state.companyId,
    //     isadmin: this.props.getUserData().isadmin,
    //     userCompanyId: this.props.getUserData().userCompanyId,
    //     userId: this.props.getUserData().userId
    //   });
    //   console.log(this.state.vehicleIds);

    //   await this.multiTrackingStore.getSelectedVehicles({
    //     vehicleIds: this.state.vehicleIds,
    //   });

    //   await this.setState({ updatedPos: true });
      
    //   const filterVehicles = await this.state.position.map((objB) =>
    //     this.multiTrackingStore.multiTrackingArray.find(
    //       (objA) => objB.vehicleId === objA.vehicleId
    //     )
    //   );

    //   console.log(this.multiTrackingStore.vehiCleLiveLatLongOb)

    //   let liveLatLong = filterVehicles?.map((val) => {
    //     return {
    //       ...val,
    //       polyLine:
    //         this.multiTrackingStore.vehiCleLiveLatLongObj[val.vehicleId],
    //     };
    //   });

    //   // await this.setState({ position: liveLatLong });
    //   this.multiTrackingStore.vehicleLiveLatLongArray = liveLatLong;
    //   this.context.viewStateStore.setLiveLatLong(liveLatLong);

    //   await this.setState({ updateState: 1 });
    // }, interval);

    this.intervalId = setInterval(async () => {
      //console.log(this.state.vehicleIds)
      // await this.multiTrackingStore.loadData({
      //   offset: (this.state.currentPage - 1) * this.state.pageSize,
      //   limit: this.state.pageSize,
      //   searchField: this.state.searchField,
      //   companyId: this.state.companyId,
      //   isadmin: this.props.getUserData().isadmin,
      //   userCompanyId: this.props.getUserData().userCompanyId,
      //   userId: this.props.getUserData().userId
      // });
      await this.handleSearch(true);
      //console.log(this.state.vehicleIds);
      //console.log(this.state.selectedRowKeys);
    //  console.log(this.state.vehicleIds)
      await this.multiTrackingStore.getSelectedVehicles({
        vehicleIds: this.state.vehicleIds,
      });

      await this.setState({ updatedPos: true });
      //console.log(this.state.position)
      //console.log(this.multiTrackingStore.allVehicles)
      
      const filterVehicles = await this.state.position.map((objB) =>
        this.multiTrackingStore.multiTrackingArray.find(
          (objA) => objB.vehicleId === objA.vehicleId
        )
      );
      //console.log(filterVehicles);
      //console.log(this.multiTrackingStore.vehiCleLiveLatLongObj[val.vehicleId],);

      //console.log(this.multiTrackingStore.vehiCleLiveLatLongOb)
      
      let liveLatLong = filterVehicles?.map((val) => {
        return {
          ...val,
          polyLine:
            this.multiTrackingStore.vehiCleLiveLatLongObj[val.vehicleId],
        };
      });

     // console.log(liveLatLong);

      // await this.setState({ position: liveLatLong });
      this.multiTrackingStore.vehicleLiveLatLongArray = liveLatLong;
      await this.context.viewStateStore.setLiveLatLong(liveLatLong);

    // console.log(this.context.viewStateStore?.vehicleLiveLatLong[0].latitude)
      
      await this.setState({ updateState: 1 });
    }, interval);

    this.setState({ pageSize: 50 });

    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 1);

    this.setState({ updateState: 1 });
    this.attachScrollListener();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResizeWindow);

    const tableBody = document.querySelector(".ant-table-body");
    if (tableBody) {
      tableBody.removeEventListener("scroll", this.handleTableScroll);
      tableBody.hasScrollListener = false;
    }

     this.context.viewStateStore.setLiveLatLong([]);
  this.multiTrackingStore.allVehicles = [];
  this.multiTrackingStore.vehicleLiveLatLongArray = [];
  }

  handleResizeWindow = () => {
    this.setState({
      clientHeight: window.innerHeight,
    });
  };
  handleMapTypeChange = async (comp) => {
    await this.setState({ mapType: comp.target.value, listUpdated: 1 });
  };

  async componentDidUpdate(prevProps, prevState) {
    // When the modal is visible, trigger a map refresh to ensure it renders properly
    // await this.liveLatLongGetting()

    if (
      this.state.mapModalIndex &&
      prevState.mapModalIndex !== this.state.mapModalIndex &&
      this.state.count == 0
    ) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }

    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    });

    if (prevState.searchData.length !== this.state.searchData.length) {
      this.attachScrollListener();
   }
  }

  attachScrollListener = () => {
  const tableBody = document.querySelector(".ant-table-body");

  if (tableBody && !tableBody.hasScrollListener) {
    tableBody.addEventListener("scroll", this.handleTableScroll);
    tableBody.hasScrollListener = true; // prevent multiple bindings
  }
};


  liveLatLongGetting = async () => {
    await this.multiTrackingStore.getSelectedVehicles({
      vehicleIds: this.state.vehicleIds,
    });

    await this.setState({ updatedPos: true });

    const filterVehicles = await this.state.position.map((objB) =>
      this.multiTrackingStore.allVehicles.find(
        (objA) => objB.vehicleId === objA.vehicleId
      )
    );

    let liveLatLong = filterVehicles.map((val) => {
      return {
        ...val,
        polyLine: this.multiTrackingStore.vehiCleLiveLatLongObj[val.vehicleId],
      };
    });

    // await this.setState({ position: liveLatLong });
    this.multiTrackingStore.vehicleLiveLatLongArray = liveLatLong;
    await this.context.viewStateStore.setLiveLatLong(liveLatLong);

    await this.setState({ updateState: 1 });
  };

  async handleChange(comp) {
    await this.setState({ selectedRowKeys: [] });
    await this.setState({ companyId: comp.value, loadList: 1 });
    await this.handleSearch();
  }

 handleSearch = (reset = true) => {
  console.log('in handlesearch', reset);

  if (this.state.loading) return Promise.resolve();

  return new Promise((resolve, reject) => {
    this.setState(
      {
        loading: true,
        currentPage: reset ? 1 : this.state.currentPage,
        searchData: reset ? [] : this.state.searchData,
        hasMore: true,
      },
      async () => {
        try {
          const {
            currentPage,
            pageSize,
            searchData,
            searchField,
            companyId,
            poupSearch
          } = this.state;

          await this.multiTrackingStore.loadData({
            offset: (currentPage - 1) * pageSize,
            limit: pageSize,
            searchField,
            companyId,
            isadmin: this.props.getUserData().isadmin,
            userCompanyId: this.props.getUserData().userCompanyId,
            userId: this.props.getUserData().userId,
            poupSearch,
            vehicleIds: this.state.vehicleIds
          });

          const newData = this.multiTrackingStore.multiTrackingArray || [];

          this.setState({
            searchData: [...searchData, ...newData],
            currentPage: currentPage + 1,
            hasMore: newData.length === pageSize,
            loading: false,
          }, resolve); // 🔥 resolve AFTER everything finishes
        } catch (e) {
          this.setState({ loading: false });
          reject(e);
        }
      }
    );
  });
};

  handleTableScroll = (e) => {
  const { scrollTop, scrollHeight, clientHeight } = e.target;

  if (
    scrollTop + clientHeight >= scrollHeight - 30 &&
    this.state.hasMore &&
    !this.state.loading
  ) {
    console.log("LOAD NEXT 50");
    this.handleSearch(false);
  }
};


  customIcon = new Icon({
    // iconUrl: "https://cdn-icons-png.flaticon.com/512/447/447031.png",
    iconUrl: require("../assets/images/car.png"),
    iconSize: [38, 38], // size of the icon
  });
  createClusterCustomIcon = function (cluster) {
    return new divIcon({
      html: `<span class="cluster-icon">${cluster.getChildCount()}</span>`,
      className: "custom-marker-cluster",
      iconSize: point(45, 45, true),
    });
  };

  openMapModal = async (index) => {
    // Close the previous map modal if it is open
    if (this.state.mapModalIndex !== null) {
      this.setState({ mapModalIndex: null });
    }

    // Open the new map modal and trigger resize event to ensure proper map rendering
    if (index === 0) {
      await this.setState({ mapModalIndex: index });
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 1);

      await this.setState({ count: 2 });
    } else {
      this.setState({ mapModalIndex: index, count: 0 });
    }
  };

  // Function to close the map modal
  closeMapModal = () => {
    this.setState({ mapModalIndex: null });
    if (this.state.count === 2) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 1);
    }
  };

  openModal = (value) => {
    this.setState({
      showModal: true,
      modalValue: value,
    });
  };

  closeModal = () => {
    this.setState({
      showModal: false,
    });
  };

  mapShowFun = () => {
    this.setState({
      mapShow: true,
      // latLongForModal: val,
    });
  };

  toggleDrawer = () => {
    this.setState({ showSlider: !this.state.showSlider });
  };
  searchInput = async (e) => {
    const value = e.target.value;
    await this.setState({ poupSearch: value });
    if (value.length > 3 || value.length === 0) {
      if (this.state.companyId) {
        await this.handleSearch(true);
    //     await this.multiTrackingStore.loadData({
    //       offset: (this.state.currentPage - 1) * this.state.pageSize,
    //       limit: this.state.pageSize,
    //       searchField: this.state.searchField,
    //       companyId: this.state.companyId,
    //       poupSearch: value,
    //     });
    //    // await this.setState({ loadList: 1 });
    //      await this.setState({
    //   searchData: this.multiTrackingStore?.multiTrackingArray,
    //   loadList: 1,
    // });
      }
    }
  };

  searchClick = async () => {
    await this.multiTrackingStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
      poupSearch: this.state.poupSearch,
    });
    await this.setState({ loadList: 0 });
  };

  searchByVehicleNo = async (value) => {
    let inputData = value.toLowerCase();
    if (inputData.length === 0) {
      await this.setState({
        searchData: this.multiTrackingStore?.multiTrackingArray,
      });
    } else {
      const data = this.multiTrackingStore?.multiTrackingArray.filter(
        (vehicleNo) => {
          return vehicleNo.vehicleNo.toLowerCase().includes(inputData);
        }
      );
      await this.setState({ searchData: data });

      const filteredRowKeys = data.map((vehicle) => vehicle.vehicleId);
    }
  };

  handleLoading = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
  };
  render() {
    const mergedColumns = this.state.columns.map((col, index) => ({
      ...col,
      onHeaderCell: (column) => ({
        width: column.width,
        onResize: this.handleResize(index),
      }),
    }));
    return (
      <>
        <Row className="multi-tracking-wrapper">
          <Col span={6} className="left-panel">
            <Card>
              <div className="sml-search-input">
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={(val) => this.handleChange(val)}
                  style={{ width: "100%", marginBottom: "15px" }}
                />
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Input
                    style={{
                      width: "100%",
                      borderRadius: "25px",
                      marginInlineEnd: "8px",
                    }}
                    // onChange={async (e) => {
                    //   let searchedArray = await this.searchByVehicleNo(
                    //     e.target.value
                    //   );
                    //   await this.setState({
                    //     searchText: e.target.value,
                    //   });
                    // }}
                    placeholder={this.context.translate(
                      "_FLEET_DASHBORD_NAVIRIGHT_SEARCHVEHICLE_"
                    )}
                  //  onChange={this.searchInput(e)}
                    onChange={(e) => {
                    //   this.setState({ searchGeoFence: e.target.value });
                       this.searchInput(e);
                    }}
                  />
                  <Button
                    className="clearButton"
                    // type="primary"
                    // style={{ marginInlineStart: "8px", height: "38px" }} // Adjust margin as needed
                    onClick={async () => {
                      this.context.viewStateStore.setLiveLatLong("");
                      this.setState({
                        position: [],
                        selectedRowKeys: [],
                        selectedRowsInfo: [],
                        vehicleIds: [],
                      });
                    }}
                  >
                    {this.context.translate("_CLEAR_ALL_")}
                  </Button>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div>
                  <Spin spinning={this.state.loading}>
                    <Table
                      style={{ marginTop: "15px" }}
                      className="mainTbl"
                      components={{
                        header: {
                          cell: ResizableTable,
                        },
                      }}
                      rowSelection={{
                        columnWidth: 6,
                        selectedRowKeys: this.state.selectedRowKeys, // selected checkbox state
                        // if select vehicle id that time call

                        onSelect: async (
                          record,
                          selected,
                          selectedRows,
                          nativeEvent
                        ) => {
                          // Function called when a row is selected/deselected
                           // console.log(selected);
                           // console.log(selectedRows);
                            

                          if (!selected) {
                            
                            let filter =
                              await this.state.selectedRowKeys.filter(
                                (val) => val !== record.vehicleId
                              );
                            let filterInfo =
                              await this.state.selectedRowsInfo.filter(
                                (val) => val.vehicleId !== record.vehicleId
                              );
                             // console.log(filter);

                            await this.setState({
                              selectedRowKeys: filter,
                              selectedRowsInfo: filterInfo,
                            });
                          }

                          await this.multiTrackingStore.getSelectedVehicles({
                            vehicleIds: this.state.selectedRowKeys,
                            selectedRowsInfo: this.state.selectedRowsInfo,
                          });
                          const filteredRowKeys =
                            await this.state.selectedRowKeys.filter(
                              (key) => key !== undefined && key !== null
                            );
                          await this.setState({
                            position: this.state.selectedRowsInfo,
                            vehicleIds: filteredRowKeys,
                          });

                          await this.liveLatLongGetting();
                          await this.setState({ update: 1 });
                        },

                        //onchange function
                        onChange: async (selectedRowKeys, selectedRows) => {
                          const allRowsSelected =
                            selectedRowKeys.length ===
                            this.multiTrackingStore?.multiTrackingArray.length;

                          if (allRowsSelected) {
                            // Display information for the first 8 vehicles on the map
                            const first8VehicleIds = selectedRowKeys.slice(
                              0,
                              8
                            );
                            await this.multiTrackingStore.getSelectedVehicles({
                              vehicleIds: first8VehicleIds,
                              selectedVehicles: selectedRows.slice(0, 8),
                            });
                            await this.setState({
                              position: selectedRows.slice(0, 8),
                              vehicleIds: first8VehicleIds,
                              selectedRowKeys: selectedRowKeys.slice(0, 8),
                              selectedRowsInfo: selectedRows.slice(0, 8),
                            });
                            await this.liveLatLongGetting();
                          } else if (selectedRowKeys.length > 8) {
                            Modal.warning({
                              title: "Alert",
                              content: this.context.translate(
                                "_ALERT_MSG_DISPLAY_8_VEHICLES_AT_TIME_"
                              ),
                            });
                          } else {
                            // Process selected rows as before

                            if (this.state.searchText.length > 0) {
                              let vehicleIds = [
                                ...this.state.selectedRowKeys,
                                ...selectedRowKeys,
                              ];
                              const uniqVehicleIds = [...new Set(vehicleIds)];
                              let selectedRowInfo = [
                                ...this.state.selectedRowsInfo,
                                ...selectedRows,
                              ];
                              let uniqueVehicleRecords = selectedRowInfo.filter(
                                (record, index, self) =>
                                  index ===
                                  self.findIndex(
                                    (r) => r.vehicleId === record.vehicleId
                                  )
                              );

                              if (uniqVehicleIds.length > 8) {
                                Modal.warning({
                                  title: "Alert",
                                  content: this.context.translate(
                                    "_ALERT_MSG_DISPLAY_8_VEHICLES_AT_TIME_"
                                  ),
                                });
                                await this.setState({
                                  selectedRowKeys: uniqVehicleIds.slice(0, 8),
                                  selectedRowsInfo: uniqueVehicleRecords.slice(
                                    0,
                                    8
                                  ),
                                  position: uniqueVehicleRecords.slice(0, 8),
                                });
                              } else {
                                await this.setState({
                                  selectedRowKeys: uniqVehicleIds,
                                  selectedRowsInfo: uniqueVehicleRecords,
                                  position: uniqueVehicleRecords,
                                });
                              }
                            } else {
                              await this.setState({
                                position: selectedRows,
                                selectedRowKeys: selectedRowKeys,
                                selectedRowsInfo: selectedRows,
                              });
                            }
                          }

                          this.handleLoading();
                        },
                      }}
                      pagination={false}
                      rowKey="vehicleId"
                      columns={mergedColumns}
                      dataSource={[...this.state.searchData]}
                      // scroll={{ y: 490 }}
                      scroll={{
                        y: this.state.clientHeight - 240, //180
                      }}
                      loading={this.LiveTrackingStore?.loading}
                      //onScroll={this.handleTableScroll}
                    />
                    {this.state.loading && (
                        <div style={{ textAlign: "center", padding: 10 }}>
                          <Spin />
                        </div>
                    )}
                  </Spin>
                </div>
              </div>
            </Card>
          </Col>
          <Col span={18}>
            <Image
              style={{ height: "93vh" }}
              src={require("../assets/images/mapBg.jpg")}
            />

            <Popover
              content={
                <Radio.Group
                  options={this.mapOptions}
                  onChange={this.handleMapTypeChange}
                  value={this.state.mapType}
                  optionType="button"
                  buttonStyle="solid"
                />
              }
              placement="right"
            >
              <FloatButton
                style={{ bottom: "15px" }}
                icon={<GlobeCentralSouthAsia />}
              />
            </Popover>
          </Col>
         
          {this.context.viewStateStore?.vehicleLiveLatLong?.length > 0 &&
            this.context.viewStateStore?.vehicleLiveLatLong?.map((val, ind) => { 
             
              return(
             
               <div key={val.vehicleId}>
                <Draggable handle=".handle">
                  <Card
                    className="multiTracking-card"
                    title={
                      <>
                        <div className="title handle">
                          {val?.vehicleNo}
                          <Button
                            icon={<i class="bi bi-arrows-fullscreen" />}
                            onClick={async () => {
                              // this.mapShowFun();
                              this.openMapModal(ind);
                              // await this.setState({
                              //   mapShow: true,
                              //   // latLongForModal: val,
                              // });
                              // await this.latLongForModal(val);
                            }}
                          ></Button>
                        </div>
                      </>
                    }
                    style={{
                      width: "15%",
                      height: "38%",
                      marginLeft: "5&",
                      position: "absolute",
                      bottom: `${ind > 3 ? 51 : 10}%`,

                      insetInlineStart: `${
                        ind > 3
                          ? ind < 4
                            ? 34
                            : ind > 4
                            ? ind - 4 + 15 + 16 * (ind - 3)
                            : 15 + 16 * (ind - 3)
                          : 82 - 17 * ind
                      }%`,
                    }}
                  >
                    <PolyLineAndMapComponent
                      position={val}
                      mapType={this.state.mapType}
                      smallMap={true}
                    />
                  </Card>
                </Draggable>

                <Modal
                  className="multiTracking-popup"
                  key={`mapModal_${ind}`}
                  title=<div>
                    {val?.vehicleNo}
                    <CloseOutlined onClick={this.closeMapModal} />
                  </div>
                  centered
                  bodyStyle={{
                    height: "500px",
                    //width: "900px",
                    padding: "0px",
                  }} // Adjust the dimensions as needed
                  width={1000}
                  visible={this.state.mapModalIndex === ind}
                  onCancel={this.closeMapModal}
                  footer={null}
                  maskClosable={false}
                >
                  <PolyLineAndMapComponent
                    position={val}
                    mapType={this.state.mapType}
                    mapWidth={true}
                  />
                </Modal>
              </div>
            )})}
        </Row>
      </>
    );
  }
}

MultiTracking.contextType = StoreContext;
export default observer(withRouter(MultiTracking));
